import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import CourseCard from '../components/CourseCard'
import RecomendedCourse from '../components/RecomendedCourse'
import { useState } from 'react'
import CourseListModal from '../components/CourseListModal'

export default function UpskillOverview() {
  const [isModalOpen, setModalOpen] = useState(false)

  const handleOpen = () => {
    setModalOpen(true)
  }

  const handleClose = () => {
    setModalOpen(false)
  }

  return (
    <>
      <DashboardContainer>
        <AdxActionButton
          divClick
          onClick={handleOpen}
          title="Request for Courses"
          icon="dashboard_customize"
          iconColor="alternate.main"
          iconBgColor="alternate.light"
          actionMessage="Request"
          icon2="chevron_right"
          sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}
        />
        <CourseCard />
        <RecomendedCourse />
      </DashboardContainer>
      <CourseListModal isModalOpen={isModalOpen} handleClose={handleClose} />
    </>
  )
}
